import {
  type AccountlessNatalieEventApiResponse,
  type NatalieEventDetail,
  type NatalieEventDetailData,
  type NatalieEventPublicDetail,
  type NatalieEventPublicDetailData,
  NatalieEventStatus,
} from './natalieEvent.types';

const isNatalieEventStatus = (value: string): value is NatalieEventStatus =>
  value === NatalieEventStatus.Active || value === NatalieEventStatus.Completed;

const narrowAccountlessStatus = (value: string): NatalieEventStatus => {
  if (isNatalieEventStatus(value)) return value;
  // eslint-disable-next-line no-console
  console.warn(`[mapAccountlessEventFromApi] Unknown status "${value}", defaulting to Active`);
  return NatalieEventStatus.Active;
};

export const mapNataliePublicEventDetailFromApi = (data: NatalieEventPublicDetailData): NatalieEventPublicDetail => ({
  id: data.id,
  communityId: data.community.id,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName,
  communityName: data.community.name ?? '',
  status: data.status,
  communityLogo: data.community.logoImageLink ?? null,
  videoUrl: data.videoUrl ?? null,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
  testInviteCode: data.testInviteCode ?? null,
});

export const mapNatalieEventDetailFromApi = (data: NatalieEventDetailData): NatalieEventDetail => ({
  id: data.id,
  communityId: data.community.id,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName,
  communityName: data.community.name ?? '',
  status: data.status,
  communityLogo: data.community.logoImageLink ?? null,
  videoUrl: data.videoUrl ?? null,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
  testInviteCode: data.testInviteCode ?? null,
});

export const mapAccountlessEventFromApi = (data: AccountlessNatalieEventApiResponse): NatalieEventPublicDetail => ({
  id: data.id,
  communityId: data.community.id,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName ?? '',
  communityName: data.community.name ?? '',
  // Accountless OpenAPI types `status` as plain string. Narrow at the boundary so an
  // unknown future value defaults to Active (and surfaces in dev/staging logs)
  // rather than silently flowing through.
  status: narrowAccountlessStatus(data.status),
  durationInMinutes: data.sessionDurationMinutes ?? 0,
  communityLogo: data.community.logoImageLink ?? null,
  videoUrl: null,
  testInviteCode: data.testInviteCode ?? null,
});
